import { createApp } from "vue";
import router from "./router/index.js";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.js";
import vuetify from "./plugins1/vuetify";
// import { loadFonts } from "./plugins/webfontloader";
import App from "./App.vue";
import VueDatePicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";

// loadFonts();

createApp(App)
  .use(router)
  .use(vuetify)
  .component("VueDatePicker", VueDatePicker)
  .mount("#app");
